import { render, staticRenderFns } from "./MenuItemHeader.vue?vue&type=template&id=2706b6ea"
import script from "./MenuItemHeader.vue?vue&type=script&lang=js"
export * from "./MenuItemHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports